export default __webpack_public_path__ + "static/media/smartphone-1.8498423c.png";